import { useState } from "react";

import { Licenses } from "common/components/subscriptions";
import { Button } from "common/components/ui/Button";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function ManageSubscriptionButton() {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button size={isDesktop ? "sm" : "lg"} onClick={() => setIsOpen(true)}>
        Manage subscription
      </Button>

      <Licenses isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
}
